import React from 'react';
import { Container, Grid, Paper, Typography, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Sidebar from '../Sidebar/Sidebar';
import useAuth from '../../hooks/useAuth';
import DicomDePseudoPanel from './DicomDePseudoPanel';

const PseudoDicomDePseudonymizerPage = () => {
  const { isLoggedIn, user, isLoading } = useAuth();
  const { t } = useTranslation();

  if (!isLoggedIn || isLoading) {
    return (
      <>
        <Sidebar user={user} />
        <Container maxWidth="xl">
          <Paper 
            elevation={0} 
            sx={{ 
              p: { xs: 2, md: 4 }, 
              mt: 4, 
              borderRadius: 3, 
              border: '1px solid', 
              borderColor: 'divider', 
              bgcolor: 'background.paper' 
            }}
          >
            <Skeleton variant="text" width={300} height={50} />
            <Skeleton variant="text" width={600} height={32} sx={{ mb: 3 }} />
            <Skeleton variant="rectangular" height={400} sx={{ borderRadius: 2 }} />
          </Paper>
        </Container>
      </>
    );
  }

  return (
    <>
      <Sidebar user={user} />
      <Container maxWidth="xl">
        <Paper 
          elevation={0} 
          sx={{ 
            p: { xs: 2, md: 4 }, 
            mt: 4, 
            mb: 5,
            borderRadius: 3, 
            border: '1px solid', 
            borderColor: 'divider', 
            bgcolor: 'background.paper' 
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary', mb: 1 }}>
                {t('DicomDePseudo.title', 'De-pseudonymizácia DICOM')}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                {t('DicomDePseudo.subtitle', 'Nahrajte pseudonymizované DICOM súbory. Systém automaticky vyhľadá Vault kľúč v metadátach a obnoví pôvodné hodnoty.')}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <DicomDePseudoPanel />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </>
  );
};

export default PseudoDicomDePseudonymizerPage;